import { GET_LEADS_ALL_VALUATIONS_REQUEST_SUCCESS, GET_LEADS_ALL_VALUATIONS_REQUEST_FAILURE } from '../constants/cap.constants';

export const getLeadsAllValuationsRequestSuccess = payload => ({ type: GET_LEADS_ALL_VALUATIONS_REQUEST_SUCCESS, payload });
export const getLeadsAllValuationsRequestFailure = error => ({ type: GET_LEADS_ALL_VALUATIONS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_leads_all_valuations.actions.js